/**
 * Navigation Styles Component
 *
 * Centralized styling for all navigation elements in the header.
 * Single source of truth for all CSS classes - no duplication!
 */

import {
  COLORS,
  TYPOGRAPHY,
  LAYOUT,
  EFFECTS,
  STATES,
  HEADER_STYLES,
} from "./nav-styles/styleConstants";
import {
  combineClasses,
  BASE_COMBINATIONS,
  NAVIGATION_STYLES,
} from "./nav-styles/styleCompositions";
import {
  DropdownIcon,
  MobileDropdownIcon,
  useNavigationStyles,
  NavigationLink,
  NavigationButton,
  NavigationDropdown,
} from "./nav-styles/NavigationComponents";

// Export all components and utilities
export {
  useNavigationStyles,
  NavigationLink,
  NavigationButton,
  NavigationDropdown,
  DropdownIcon,
  MobileDropdownIcon,
  NAVIGATION_STYLES,
  COLORS,
  TYPOGRAPHY,
  LAYOUT,
  EFFECTS,
  STATES,
  BASE_COMBINATIONS,
  HEADER_STYLES,
  combineClasses,
};

// Default export for backward compatibility
const NavigationStylesExport = {
  useNavigationStyles,
  NavigationLink,
  NavigationButton,
  NavigationDropdown,
  DropdownIcon,
  MobileDropdownIcon,
  NAVIGATION_STYLES,
  COLORS,
  TYPOGRAPHY,
  LAYOUT,
  EFFECTS,
  STATES,
  BASE_COMBINATIONS,
  HEADER_STYLES,
};

export default NavigationStylesExport;
